<template>
  <ul class="tw-flex tw-flex-col tw-gap-3">
    <li
      v-for="(step, idx) of steps"
      :key="idx"
      :class="stepClasses(idx)"
    >
      <div
        :class="[
          'tw-flex tw-flex-col tw-items-center',
          active < idx && 'tw-gap-y-1',
        ]"
      >
        <StepIcon
          :active="active >= idx"
          class="tw-shrink-0"
        />
        <span
          :class="[
            'tw-w-0.5 tw-h-full tw-rounded-sm',
            active >= idx ? 'tw-bg-primary-200' : 'tw-bg-gray-400',
          ]"
        ></span>
      </div>
      <div class="tw-pb-8">
        <p
          :class="[
            active >= idx ? 'tw-text-primary-800' : 'tw-text-gray-800',
            'tw-font-semibold tw-mb-0.5',
          ]"
        >
          {{ step.title }}
        </p>
        <p
          :class="[
            active >= idx ? 'tw-text-primary-800' : 'tw-text-gray-600',
            'tw-mb-0',
          ]"
        >
          {{ step.description }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import StepIcon from "./StepIcon.vue";

interface Step {
  title: string;
  description: string;
}

const props = withDefaults(
  defineProps<{
    steps: Step[];
    active: number;
  }>(),
  {
    steps: () => [],
    active: 0,
  }
);

const stepClasses = computed(() => {
  return (idx: number) => ({
    "tw-flex tw-gap-x-4": true,
    active: props.active === idx,
    "tw-opacity-50": props.active > idx,
    "tw-opacity-60": props.active === idx - 2,
    "tw-opacity-80": props.active === idx - 1,
  });
});
</script>
